import { submitContactUs } from '@gonfalon/openapi/operations/submitContactUs';
import { submitContactUsForm } from '@gonfalon/openapi/operations/submitContactUsForm';
import { submitContactUsFormPublic } from '@gonfalon/openapi/operations/submitContactUsFormPublic';
import { useMutation } from '@tanstack/react-query';

import { createMutationHook } from '../internal/createMutationHook';
import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';

export function useSubmitContactUs() {
  return useMutation({
    mutationFn: async (input: Parameters<typeof submitContactUs>[0]) =>
      reactQueryResponseAdapter(submitContactUs(input)),
  });
}

export const useSubmitContactUsForm = createMutationHook(submitContactUsForm);

export const useSubmitContactUsFormPublic = createMutationHook(submitContactUsFormPublic);
